import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCountdown } from "../helper/Countdown";
import toast from "react-hot-toast";
import brotherProducts from "../data/hp-products.json";
import canonProducts from "../data/epson-product.json";

const DealsOne = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  const getImage = (item) => {
    if (!item) return "/assets/img/placeholder.png";
    if (Array.isArray(item.imageUrl) && item.imageUrl.length > 0)
      return item.imageUrl[0];
    if (typeof item.imageUrl === "string" && item.imageUrl.trim())
      return item.imageUrl;
    return "/assets/img/placeholder.png";
  };

  useEffect(() => {
    setProducts([...brotherProducts, ...canonProducts]);
  }, []);

  const [timeLeft, setTimeLeft] = useState(getCountdown());
  useEffect(() => {
    const interval = setInterval(() => setTimeLeft(getCountdown()), 1000);
    return () => clearInterval(interval);
  }, []);

  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login-now");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const existing = cart.find((i) => i.id === product.id);

    if (existing) existing.quantity++;
    else cart.push({ ...product, quantity: 1 });

    sessionStorage.setItem("cart", JSON.stringify(cart));
    window.dispatchEvent(new Event("cart-updated"));
    toast.success(`${product.name} added to cart!`);
  };

  const formatCategory = (str) =>
    str.replace(/[-_]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

  const productsWithRandomData = useMemo(() => {
    return products.map((item) => ({
      ...item,
      rating: (Math.random() * 1 + 4).toFixed(1),
      reviews: Math.floor(Math.random() * 400) + 70,
      features: ["Compact", "Wireless", "Quiet Mode", "Energy Saver"]
        .sort(() => 0.5 - Math.random())
        .slice(0, 2),
      formattedCategory: formatCategory(item.category),
    }));
  }, [products]);

  return (
    <section className="home-deals-sec">
      <div className="home-container">
        {/* Heading */}
        <div className="home-heading">
          <h2>Top Home Printers</h2>
          <p>
            Compact, quiet and budget-friendly printing solutions designed for
            everyday home & family use.
          </p>
        </div>

        {/* GRID */}
        <div className="home-grid">
          {productsWithRandomData.map((item) => (
            <div key={item.id} className="home-card">
              {/* IMAGE */}
              <Link to={`/product-details/${item.id}`} className="home-img-box">
                <img src={getImage(item)} alt={item.name} />
              </Link>

              {/* CONTENT */}
              <div className="home-content">
                <p className="home-category">{item.formattedCategory}</p>

                <Link to={`/product-details/${item.id}`} className="home-title">
                  {item.name}
                </Link>

                <p className="home-desc">
                  {item.description
                    ? item.description.split(" ").slice(0, 12).join(" ") + "..."
                    : "A dependable and family-friendly printer built for everyday use."}
                </p>

                <div className="home-tags">
                  {item.features.map((tag, i) => (
                    <span key={i} className="home-chip">
                      {tag}
                    </span>
                  ))}
                </div>

                {/* Bottom */}
                <div className="home-bottom">
                  <div className="home-price">${item.price}</div>
                  <button
                    className="home-btn"
                    onClick={() => handleAddToCart(item)}
                  >
                    Add to Cart
                  </button>
                </div>

                <div className="home-rating">
                  ⭐ {item.rating} <span>({item.reviews} reviews)</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* STYLES */}
      <style>{`
        .home-deals-sec {
          padding: 70px 0;
          background: #f7f9fc;
        }

        .home-container {
          max-width: 1300px;
          margin: auto;
          padding: 0 20px;
        }

        /* Heading */
        .home-heading {
          text-align: center;
          margin-bottom: 40px;
        }

        .home-heading h2 {
          font-size: 32px;
          font-weight: 800;
          color: #1a1a1a;
        }

        .home-heading p {
          max-width: 650px;
          margin: 10px auto 0;
          color: #666;
          font-size: 15px;
          line-height: 1.6;
        }

        /* Grid */
        .home-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 26px;
        }

        /* Card */
        .home-card {
          background: #fff;
          border-radius: 18px;
          box-shadow: 0px 5px 18px rgba(0,0,0,0.08);
          overflow: hidden;
          transition: 0.3s ease;
          display: flex;
          flex-direction: column;
        }

        .home-card:hover {
          transform: translateY(-6px);
          box-shadow: 0px 12px 30px rgba(0,0,0,0.12);
        }

        /* Image */
        .home-img-box {
          padding: 26px;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 220px;
        }

        .home-img-box img {
          width: 75%;
          transition: 0.3s ease;
        }

        .home-card:hover img {
          transform: scale(1.06);
        }

        /* Content */
        .home-content {
          padding: 20px;
          background: #fafafa;
          flex-grow: 1;
        }

        .home-category {
          font-size: 11px;
          color: #888;
          font-weight: 600;
        }

        .home-title {
          font-size: 18px;
          font-weight: 700;
          color: #111;
          text-decoration: none;
          margin: 6px 0 10px;
          display: block;
        }

        .home-desc {
          font-size: 13px;
          color: #666;
          line-height: 1.5;
          margin-bottom: 14px;
        }

        /* Tags */
        .home-tags {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          margin-bottom: 18px;
        }

        .home-chip {
          background: #e8f3ff;
          color: #0b61d6;
          padding: 6px 12px;
          border-radius: 20px;
          font-weight: 600;
          font-size: 11px;
        }

        /* Bottom area */
        .home-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        }

        .home-price {
          font-size: 22px;
          font-weight: 800;
          color: #0b61d6;
        }

        .home-btn {
          background: #0b61d6;
          color: white;
          padding: 10px 18px;
          border: none;
          border-radius: 10px;
          font-size: 13px;
          font-weight: 600;
          transition: 0.25s ease;
        }

        .home-btn:hover {
          background: #084eb3;
          transform: translateY(-2px);
        }

        .home-rating {
          font-size: 13px;
          color: #333;
          border-top: 1px solid #ddd;
          padding-top: 8px;
        }

        .home-rating span {
          color: #777;
        }

      `}</style>
    </section>
  );
};

export default DealsOne;
